import Icon from 'js/components/Icon';

const CopyIcon = ({ handleCopy, copyIconRef }) => (
  <div onClick={(e) => handleCopy(e)} className='copy-icon' ref={copyIconRef}>
    <Icon icon='copy' light />
  </div>
);

export default CopyIcon;
